<template>
    <AnagraficaBarche @click_indietro="handleClickIndietro" :flagEM="true" class="pa-5" style="border-radius:0px;" />
</template>

<script>
import AnagraficaBarche from "@/components/ELECTRICALMARINE/AnagraficaBarche.vue";
export default {
  name: "EMAnagraficaBarche",
  components: {
      AnagraficaBarche,
  },
  props: {},
  data() {
    return {
        // Variabili d'appoggio
        // Modal
        // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    handleClickIndietro(){
      this.$router.push("/home/naval");
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped>
</style>